import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {openSearchForm} from '../../actions/navOptions';

class SearchIcon extends Component {

  render() {
    const {openSearchForm} = this.props;

    return (
    <div className="map-nav__btn" onClick={openSearchForm}>
      <a href="#" className="btn btn-default btn-m show-map-page">
        <div className="icon-search" />
      </a>
      Filter
    </div>
    );
  }

}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ openSearchForm }, dispatch);
}

export default connect(undefined, mapDispatchToProps)(SearchIcon);



// WEBPACK FOOTER //
// ./src/containers/NavOptions/SearchIcon.js